import { gql } from 'apollo-angular';
import { Injectable } from '@angular/core';
import * as Apollo from 'apollo-angular';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = {
  [_ in K]?: never;
};
export type Incremental<T> =
  | T
  | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string };
  String: { input: string; output: string };
  Boolean: { input: boolean; output: boolean };
  Int: { input: number; output: number };
  Float: { input: number; output: number };
  Date: { input: any; output: any };
  Json: { input: any; output: any };
};

export type CheckLoginStatusDataOutput = {
  atk?: Maybe<Scalars['String']['output']>;
  rtk?: Maybe<Scalars['String']['output']>;
};

export type CheckLoginStatusOutput = {
  data?: Maybe<CheckLoginStatusDataOutput>;
  message?: Maybe<Scalars['String']['output']>;
  statusCode?: Maybe<Scalars['Int']['output']>;
};

export type DateTimeFilter = {
  equals?: InputMaybe<Scalars['Date']['input']>;
  gt?: InputMaybe<Scalars['Date']['input']>;
  gte?: InputMaybe<Scalars['Date']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Date']['input']>>>;
  lt?: InputMaybe<Scalars['Date']['input']>;
  lte?: InputMaybe<Scalars['Date']['input']>;
  not?: InputMaybe<Scalars['Date']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['Date']['input']>>>;
};

export type DeleteAccountOutput = {
  message?: Maybe<Scalars['String']['output']>;
  statusCode?: Maybe<Scalars['Int']['output']>;
};

export type DeviceList = {
  id?: Maybe<Scalars['String']['output']>;
  metadata?: Maybe<Scalars['Json']['output']>;
};

export type GetDevicesOutput = {
  data?: Maybe<Array<Maybe<DeviceList>>>;
  message?: Maybe<Scalars['String']['output']>;
  statusCode?: Maybe<Scalars['Int']['output']>;
};

export type GetDidDataOutput = {
  did?: Maybe<Scalars['String']['output']>;
};

export type GetDidOutput = {
  data?: Maybe<GetDidDataOutput>;
  message?: Maybe<Scalars['String']['output']>;
  statusCode?: Maybe<Scalars['Int']['output']>;
};

export type GetProfileImageGroupsOutput = {
  data?: Maybe<Array<Maybe<ProfileImageGroup>>>;
  message?: Maybe<Scalars['String']['output']>;
  statusCode?: Maybe<Scalars['Int']['output']>;
};

export type GetReferralCodeOutput = {
  data?: Maybe<ReferralCodeOutput>;
  message?: Maybe<Scalars['String']['output']>;
  statusCode?: Maybe<Scalars['Int']['output']>;
};

export type LoginDataOutput = {
  atk?: Maybe<Scalars['String']['output']>;
  rtk?: Maybe<Scalars['String']['output']>;
  tmt?: Maybe<Scalars['String']['output']>;
};

export type LoginOutput = {
  data?: Maybe<LoginDataOutput>;
  message?: Maybe<Scalars['String']['output']>;
  reason?: Maybe<Scalars['String']['output']>;
  statusCode?: Maybe<Scalars['Int']['output']>;
};

export type LogoutOutput = {
  message?: Maybe<Scalars['String']['output']>;
  statusCode?: Maybe<Scalars['Int']['output']>;
};

export type Mutation = {
  createProfile?: Maybe<LoginOutput>;
  deleteAccount?: Maybe<DeleteAccountOutput>;
  deleteProfile?: Maybe<LoginOutput>;
  logout?: Maybe<LogoutOutput>;
  logoutDevices?: Maybe<LogoutOutput>;
  refreshToken?: Maybe<LoginOutput>;
  updateProfile?: Maybe<LoginOutput>;
};

export type MutationCreateProfileArgs = {
  name: Scalars['String']['input'];
  profileImageId?: InputMaybe<Scalars['String']['input']>;
  profileTypeId: Scalars['String']['input'];
};

export type MutationDeleteProfileArgs = {
  id: Scalars['String']['input'];
};

export type MutationLogoutArgs = {
  did?: InputMaybe<Scalars['String']['input']>;
};

export type MutationLogoutDevicesArgs = {
  did: Scalars['String']['input'];
};

export type MutationUpdateProfileArgs = {
  id: Scalars['String']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  profileImageId?: InputMaybe<Scalars['String']['input']>;
  profileTypeId?: InputMaybe<Scalars['String']['input']>;
};

export type NumberFilterOptions = {
  equals?: InputMaybe<Scalars['Int']['input']>;
  gt?: InputMaybe<Scalars['Int']['input']>;
  gte?: InputMaybe<Scalars['Int']['input']>;
  lt?: InputMaybe<Scalars['Int']['input']>;
  lte?: InputMaybe<Scalars['Int']['input']>;
};

export enum Order {
  Asc = 'asc',
  Desc = 'desc',
}

export type Profile = {
  isDefault?: Maybe<Scalars['Boolean']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  profileImage?: Maybe<ProfileImage>;
  profileType?: Maybe<ProfileType>;
};

export type ProfileImage = {
  id?: Maybe<Scalars['String']['output']>;
  path?: Maybe<Scalars['String']['output']>;
};

export type ProfileImageGroup = {
  ProfileImage?: Maybe<Array<Maybe<ProfileImage>>>;
  name?: Maybe<Scalars['String']['output']>;
};

export type ProfileType = {
  id?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

export type Query = {
  approveTvLogin?: Maybe<TvLoginOutput>;
  checkLoginStatus?: Maybe<CheckLoginStatusOutput>;
  getAllDevices?: Maybe<GetDevicesOutput>;
  getDevices?: Maybe<GetDevicesOutput>;
  getDid?: Maybe<GetDidOutput>;
  getProfileImageGroups?: Maybe<GetProfileImageGroupsOutput>;
  getReferralCode?: Maybe<GetReferralCodeOutput>;
  login?: Maybe<LoginOutput>;
  requestLogin?: Maybe<RequestLoginOutput>;
  requestTvLogin?: Maybe<RequestTvLoiginOutput>;
  selectProfile?: Maybe<SelectProfileOutput>;
};

export type QueryApproveTvLoginArgs = {
  code: Scalars['Int']['input'];
};

export type QueryCheckLoginStatusArgs = {
  requestId: Scalars['String']['input'];
};

export type QueryLoginArgs = {
  code: Scalars['String']['input'];
  mobile: Scalars['String']['input'];
  referralCode?: InputMaybe<Scalars['String']['input']>;
  utm?: InputMaybe<Scalars['String']['input']>;
};

export type QueryRequestLoginArgs = {
  mobile: Scalars['String']['input'];
};

export type QuerySelectProfileArgs = {
  confirmationCode?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['String']['input'];
};

export type ReferralCodeOutput = {
  code?: Maybe<Scalars['String']['output']>;
};

export type RequestLoginDataOutput = {
  isValidFor?: Maybe<Scalars['Int']['output']>;
};

export type RequestLoginOutput = {
  data?: Maybe<RequestLoginDataOutput>;
  message?: Maybe<Scalars['String']['output']>;
  statusCode?: Maybe<Scalars['Int']['output']>;
};

export type RequestTvLoiginOutput = {
  data?: Maybe<TvLoginReuqestOutput>;
  message?: Maybe<Scalars['String']['output']>;
  statusCode?: Maybe<Scalars['Int']['output']>;
};

export type SelectProfileDataOutput = {
  atk?: Maybe<Scalars['String']['output']>;
  isValidFor?: Maybe<Scalars['Int']['output']>;
  rtk?: Maybe<Scalars['String']['output']>;
};

export type SelectProfileOutput = {
  data?: Maybe<SelectProfileDataOutput>;
  message?: Maybe<Scalars['String']['output']>;
  reason?: Maybe<Scalars['String']['output']>;
  statusCode?: Maybe<Scalars['Int']['output']>;
};

export type StringFilterOptions = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equals?: InputMaybe<Scalars['String']['input']>;
  not?: InputMaybe<Scalars['String']['input']>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};

export type Subscription = {
  watchLogin?: Maybe<WatchLoginOutput>;
};

export type SubscriptionWatchLoginArgs = {
  did: Scalars['String']['input'];
  requestId: Scalars['Int']['input'];
};

export type TvLoginOutput = {
  message?: Maybe<Scalars['String']['output']>;
  statusCode?: Maybe<Scalars['Int']['output']>;
};

export type TvLoginReuqestOutput = {
  isValidFor?: Maybe<Scalars['Int']['output']>;
  requestId?: Maybe<Scalars['Int']['output']>;
};

export enum TvWatchLoginStatus {
  Expired = 'EXPIRED',
  LoggedIn = 'LOGGED_IN',
  Waiting = 'WAITING',
}

export type User = {
  fullName?: Maybe<Scalars['String']['output']>;
  mobile?: Maybe<Scalars['String']['output']>;
};

export type WatchLoginOutput = {
  atk?: Maybe<Scalars['String']['output']>;
  rtk?: Maybe<Scalars['String']['output']>;
  status?: Maybe<TvWatchLoginStatus>;
};

export type RequestLoginQueryVariables = Exact<{
  phone: Scalars['String']['input'];
}>;

export type RequestLoginQuery = {
  requestLogin?: { statusCode?: number | null; message?: string | null } | null;
};

export type LoginQueryVariables = Exact<{
  phone: Scalars['String']['input'];
  code: Scalars['String']['input'];
  utm?: InputMaybe<Scalars['String']['input']>;
  referralCode?: InputMaybe<Scalars['String']['input']>;
}>;

export type LoginQuery = {
  login?: {
    statusCode?: number | null;
    message?: string | null;
    data?: { atk?: string | null; rtk?: string | null; tmt?: string | null } | null;
  } | null;
};

export type RefreshTokenMutationVariables = Exact<{ [key: string]: never }>;

export type RefreshTokenMutation = {
  refreshToken?: {
    statusCode?: number | null;
    message?: string | null;
    data?: { rtk?: string | null; atk?: string | null } | null;
  } | null;
};

export type LogoutMutationVariables = Exact<{ [key: string]: never }>;

export type LogoutMutation = {
  logout?: { statusCode?: number | null; message?: string | null } | null;
};

export type ApproveTvLoginQueryVariables = Exact<{
  code: Scalars['Int']['input'];
}>;

export type ApproveTvLoginQuery = {
  approveTvLogin?: { message?: string | null; statusCode?: number | null } | null;
};

export type GetReferralCodeQueryVariables = Exact<{ [key: string]: never }>;

export type GetReferralCodeQuery = {
  getReferralCode?: {
    statusCode?: number | null;
    message?: string | null;
    data?: { code?: string | null } | null;
  } | null;
};

export type GetDidQueryVariables = Exact<{ [key: string]: never }>;

export type GetDidQuery = {
  getDid?: {
    statusCode?: number | null;
    message?: string | null;
    data?: { did?: string | null } | null;
  } | null;
};

export type GetDevicesQueryVariables = Exact<{ [key: string]: never }>;

export type GetDevicesQuery = {
  getDevices?: {
    statusCode?: number | null;
    message?: string | null;
    data?: Array<{ metadata?: any | null; id?: string | null } | null> | null;
  } | null;
};

export type GetAllDevicesQueryVariables = Exact<{ [key: string]: never }>;

export type GetAllDevicesQuery = {
  getAllDevices?: {
    statusCode?: number | null;
    message?: string | null;
    data?: Array<{ metadata?: any | null; id?: string | null } | null> | null;
  } | null;
};

export type TerminateDeviceMutationVariables = Exact<{
  did?: InputMaybe<Scalars['String']['input']>;
}>;

export type TerminateDeviceMutation = {
  logout?: { statusCode?: number | null; message?: string | null } | null;
};

export type TerminateDeviceTmtMutationVariables = Exact<{
  did: Scalars['String']['input'];
}>;

export type TerminateDeviceTmtMutation = {
  logoutDevices?: { statusCode?: number | null; message?: string | null } | null;
};

export type CreateProfileMutationVariables = Exact<{
  name: Scalars['String']['input'];
  profileTypeId: Scalars['String']['input'];
  profileImageId?: InputMaybe<Scalars['String']['input']>;
}>;

export type CreateProfileMutation = {
  createProfile?: {
    statusCode?: number | null;
    message?: string | null;
    data?: { atk?: string | null; rtk?: string | null } | null;
  } | null;
};

export type UpdateProfileMutationVariables = Exact<{
  id: Scalars['String']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  profileImageId?: InputMaybe<Scalars['String']['input']>;
  profileTypeId?: InputMaybe<Scalars['String']['input']>;
}>;

export type UpdateProfileMutation = {
  updateProfile?: {
    statusCode?: number | null;
    message?: string | null;
    data?: { atk?: string | null; rtk?: string | null } | null;
  } | null;
};

export type DeleteProfileMutationVariables = Exact<{
  id: Scalars['String']['input'];
}>;

export type DeleteProfileMutation = {
  deleteProfile?: {
    statusCode?: number | null;
    message?: string | null;
    data?: { atk?: string | null; rtk?: string | null } | null;
  } | null;
};

export type SelectProfileQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;

export type SelectProfileQuery = {
  selectProfile?: {
    statusCode?: number | null;
    message?: string | null;
    data?: { atk?: string | null; rtk?: string | null } | null;
  } | null;
};

export type GetProfileImageGroupsQueryVariables = Exact<{ [key: string]: never }>;

export type GetProfileImageGroupsQuery = {
  getProfileImageGroups?: {
    message?: string | null;
    statusCode?: number | null;
    data?: Array<{
      name?: string | null;
      ProfileImage?: Array<{ id?: string | null; path?: string | null } | null> | null;
    } | null> | null;
  } | null;
};

export type ConfirmParentalCodeQueryVariables = Exact<{
  id: Scalars['String']['input'];
  confirmationCode?: InputMaybe<Scalars['String']['input']>;
}>;

export type ConfirmParentalCodeQuery = {
  selectProfile?: {
    statusCode?: number | null;
    message?: string | null;
    data?: { atk?: string | null; rtk?: string | null } | null;
  } | null;
};

export const RequestLoginDocument = gql`
  query requestLogin($phone: String!) {
    requestLogin(mobile: $phone) {
      statusCode
      message
    }
  }
`;

@Injectable({
  providedIn: 'root',
})
export class RequestLoginQueryService extends Apollo.Query<
  RequestLoginQuery,
  RequestLoginQueryVariables
> {
  override document = RequestLoginDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const LoginDocument = gql`
  query login($phone: String!, $code: String!, $utm: String, $referralCode: String) {
    login(mobile: $phone, code: $code, utm: $utm, referralCode: $referralCode) {
      statusCode
      message
      data {
        atk
        rtk
        tmt
      }
    }
  }
`;

@Injectable({
  providedIn: 'root',
})
export class LoginQueryService extends Apollo.Query<LoginQuery, LoginQueryVariables> {
  override document = LoginDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const RefreshTokenDocument = gql`
  mutation refreshToken {
    refreshToken {
      statusCode
      message
      data {
        rtk
        atk
      }
    }
  }
`;

@Injectable({
  providedIn: 'root',
})
export class RefreshTokenMutationService extends Apollo.Mutation<
  RefreshTokenMutation,
  RefreshTokenMutationVariables
> {
  override document = RefreshTokenDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const LogoutDocument = gql`
  mutation logout {
    logout {
      statusCode
      message
    }
  }
`;

@Injectable({
  providedIn: 'root',
})
export class LogoutMutationService extends Apollo.Mutation<
  LogoutMutation,
  LogoutMutationVariables
> {
  override document = LogoutDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const ApproveTvLoginDocument = gql`
  query approveTvLogin($code: Int!) {
    approveTvLogin(code: $code) {
      message
      statusCode
    }
  }
`;

@Injectable({
  providedIn: 'root',
})
export class ApproveTvLoginQueryService extends Apollo.Query<
  ApproveTvLoginQuery,
  ApproveTvLoginQueryVariables
> {
  override document = ApproveTvLoginDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const GetReferralCodeDocument = gql`
  query getReferralCode {
    getReferralCode {
      statusCode
      message
      data {
        code
      }
    }
  }
`;

@Injectable({
  providedIn: 'root',
})
export class GetReferralCodeQueryService extends Apollo.Query<
  GetReferralCodeQuery,
  GetReferralCodeQueryVariables
> {
  override document = GetReferralCodeDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const GetDidDocument = gql`
  query getDid {
    getDid {
      statusCode
      message
      data {
        did
      }
    }
  }
`;

@Injectable({
  providedIn: 'root',
})
export class GetDidQueryService extends Apollo.Query<GetDidQuery, GetDidQueryVariables> {
  override document = GetDidDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const GetDevicesDocument = gql`
  query getDevices {
    getDevices {
      statusCode
      message
      data {
        metadata
        id
      }
    }
  }
`;

@Injectable({
  providedIn: 'root',
})
export class GetDevicesQueryService extends Apollo.Query<
  GetDevicesQuery,
  GetDevicesQueryVariables
> {
  override document = GetDevicesDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const GetAllDevicesDocument = gql`
  query getAllDevices {
    getAllDevices {
      statusCode
      message
      data {
        metadata
        id
      }
    }
  }
`;

@Injectable({
  providedIn: 'root',
})
export class GetAllDevicesQueryService extends Apollo.Query<
  GetAllDevicesQuery,
  GetAllDevicesQueryVariables
> {
  override document = GetAllDevicesDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const TerminateDeviceDocument = gql`
  mutation terminateDevice($did: String) {
    logout(did: $did) {
      statusCode
      message
    }
  }
`;

@Injectable({
  providedIn: 'root',
})
export class TerminateDeviceMutationService extends Apollo.Mutation<
  TerminateDeviceMutation,
  TerminateDeviceMutationVariables
> {
  override document = TerminateDeviceDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const TerminateDeviceTmtDocument = gql`
  mutation terminateDeviceTmt($did: String!) {
    logoutDevices(did: $did) {
      statusCode
      message
    }
  }
`;

@Injectable({
  providedIn: 'root',
})
export class TerminateDeviceTmtMutationService extends Apollo.Mutation<
  TerminateDeviceTmtMutation,
  TerminateDeviceTmtMutationVariables
> {
  override document = TerminateDeviceTmtDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const CreateProfileDocument = gql`
  mutation createProfile($name: String!, $profileTypeId: String!, $profileImageId: String) {
    createProfile(name: $name, profileTypeId: $profileTypeId, profileImageId: $profileImageId) {
      statusCode
      message
      data {
        atk
        rtk
      }
    }
  }
`;

@Injectable({
  providedIn: 'root',
})
export class CreateProfileMutationService extends Apollo.Mutation<
  CreateProfileMutation,
  CreateProfileMutationVariables
> {
  override document = CreateProfileDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const UpdateProfileDocument = gql`
  mutation updateProfile(
    $id: String!
    $name: String
    $profileImageId: String
    $profileTypeId: String
  ) {
    updateProfile(
      id: $id
      name: $name
      profileImageId: $profileImageId
      profileTypeId: $profileTypeId
    ) {
      statusCode
      message
      data {
        atk
        rtk
      }
    }
  }
`;

@Injectable({
  providedIn: 'root',
})
export class UpdateProfileMutationService extends Apollo.Mutation<
  UpdateProfileMutation,
  UpdateProfileMutationVariables
> {
  override document = UpdateProfileDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const DeleteProfileDocument = gql`
  mutation deleteProfile($id: String!) {
    deleteProfile(id: $id) {
      statusCode
      message
      data {
        atk
        rtk
      }
    }
  }
`;

@Injectable({
  providedIn: 'root',
})
export class DeleteProfileMutationService extends Apollo.Mutation<
  DeleteProfileMutation,
  DeleteProfileMutationVariables
> {
  override document = DeleteProfileDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const SelectProfileDocument = gql`
  query selectProfile($id: String!) {
    selectProfile(id: $id) {
      statusCode
      message
      data {
        atk
        rtk
      }
    }
  }
`;

@Injectable({
  providedIn: 'root',
})
export class SelectProfileQueryService extends Apollo.Query<
  SelectProfileQuery,
  SelectProfileQueryVariables
> {
  override document = SelectProfileDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const GetProfileImageGroupsDocument = gql`
  query getProfileImageGroups {
    getProfileImageGroups {
      message
      statusCode
      data {
        name
        ProfileImage {
          id
          path
        }
      }
    }
  }
`;

@Injectable({
  providedIn: 'root',
})
export class GetProfileImageGroupsQueryService extends Apollo.Query<
  GetProfileImageGroupsQuery,
  GetProfileImageGroupsQueryVariables
> {
  override document = GetProfileImageGroupsDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const ConfirmParentalCodeDocument = gql`
  query confirmParentalCode($id: String!, $confirmationCode: String) {
    selectProfile(id: $id, confirmationCode: $confirmationCode) {
      statusCode
      message
      data {
        atk
        rtk
      }
    }
  }
`;

@Injectable({
  providedIn: 'root',
})
export class ConfirmParentalCodeQueryService extends Apollo.Query<
  ConfirmParentalCodeQuery,
  ConfirmParentalCodeQueryVariables
> {
  override document = ConfirmParentalCodeDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
